import { ID } from '../../utils/codecUtils';
import { emailSchema } from '../models/email.schema';

export const get = (id: ID) => {
  return {
    endpoint: `/emails/${id}`,
    method: 'GET',
    responseSchema: emailSchema,
  } as const;
};
